import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox"; //Changed by Arun for Checkbox
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import DisabledImage from "../../../../src/Resources/Images/disable.png";

import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../../UiComponents/Transition/Transition";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";
import {
  SearchIcon,
  EditIcon,
  DownloadIcon,
  CloudOffIcon,
  DeleteIcon,
  NotInterestedIcon,
  AddIcon,
} from "../../../Resources/Icons/icons";
import moment from "moment";
import AddUserConfig from "./AddUserConfig";
import {
  GetUser,
  GetCompany,
  GetBookingCode,
  GetSubBookingCode,
  GetPolicyFindbyId,
  GetUserConfigByUserId,
  DisableUserConfig,
  GetUserConfigById,
  DeleteUserConfig,
} from "../../../Service/_index";
import Loader from "../../../UiComponents/Loader/Loader";
import { DatePicker } from "antd";
import { CSVLink } from "react-csv";
import {
  DeleteMultipleUserConfigById,
  disableMultipleUserConfigById,
} from "../../../Service/UserConfigService";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Divider, Stack, Badge } from "@mui/material";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import TabFilter from "../../Tabs/Tabs";

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "user",
    placeMent: true,
    disablePadding: false,
    label: "User",
  },
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "bookingCode",
    placeMent: true,
    disablePadding: false,
    label: "Booking Code - Sub Booking Code",
  },
  {
    id: "product",
    placeMent: true,
    disablePadding: false,
    label: "Product - Sub Product",
  },
  {
    id: "policyType",
    placeMent: true,
    disablePadding: false,
    label: "Policy Type",
  },
  {
    id: "CC",
    placeMent: true,
    disablePadding: false,
    label: "CC / GVW",
  },
  {
    id: "location",
    placeMent: true,
    disablePadding: false,
    label: "RTO Code",
  },
  {
    id: "PACover",
    placeMent: true,
    disablePadding: false,
    label: "PA Cover",
  },
  {
    id: "OD",
    placeMent: true,
    disablePadding: false,
    label: "OD %",
  },
  {
    id: "TP",
    placeMent: true,
    disablePadding: false,
    label: "TP %",
  },
  {
    id: "Net",
    placeMent: true,
    disablePadding: false,
    label: "NET %",
  },
  {
    id: "ActiveDate",
    placeMent: true,
    disablePadding: false,
    label: "Active Date",
  },
  {
    id: "DisableDate",
    placeMent: true,
    disablePadding: false,
    label: "Disable Date",
  },
  // {
  //   id: "action",
  //   placeMent: false,
  //   disablePadding: false,
  //   label: "Action",
  // },
];

const FilterOption = [
  {
    label: "ActiveData",
    isEnabled: "true",
    value: 1,
  },
  {
    label: "In ActiveData",
    isEnabled: "false",
    value: 2,
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const UserConfig = () => {
  const todayDate = new Date();
  const LastWeekDate = new Date();
  LastWeekDate.setDate(LastWeekDate.getDate() - 7);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [policyList, setPolicyList] = React.useState([]);
  // console.log(policyList, "PL");
  const [companyDetails, setCompanyDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]); //added by gokul...
  // console.log(subBookingCodeDetails, "SBCDD");
  const [openLoader, setOpenLoader] = useState(true);
  const [formType, setFormType] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedBookingCode, setSelectedBookingCode] = useState(null);
  const [selectedSubBookingCode, setSelectedSubBookingCode] = useState(null); //added by gokul..
  // console.log(selectedSubBookingCode, "SSBC");
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [selectedFilterType, setSelectedFilterType] = useState(null);
  const [productFilterData, setProductFilterData] = useState([]);
  const [policyFilterData, setPolicyFilterData] = useState([]);
  const [openDeleteConfirmBox, setOpenDeleteConfirmBox] = React.useState(false);
  const [openMultipleDeleteConfirmBox, setOpenMultipleDeleteConfirmBox] =
    React.useState(false); // Changed by Arun
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [userDetails, setUserDetails] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  // console.log(selectedUser, "CSU");
  const [reqType, setReqType] = useState(null);
  const [disabledDate, setDisabledDate] = useState("React-disable");
  const [searchTrigger, setSearchTrigger] = useState(0);
  const [checkedRows, setCheckedRows] = useState([]); //Changed by Arun for Checkbox
  const [checkboxRows, setCheckboxRows] = useState({}); //Changed by Arun for Checkbox
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  // console.log(checkboxRows, "CR");
  const [selectedTab, setSelectedTab] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedItems, setSelectedItems] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    // isView: true,
    isEdit: true,
    isDelete: true,
    isSearch: true,
    isSwitch: true,
    isMultiDelete: true,
    type: "userConfiguration",
  });

  const FilteredData = policyList.filter((el) => {
    const searchTerm = searchText.toLowerCase();
    const policyListDetails =
      `${el?.user},${el?.company},${el?.bookingCode},${el?.product},${el?.policyType},${el?.location}`.toLowerCase();
    return policyListDetails.includes(searchTerm);
  });

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    console.log(newValue, "VS");
    const selectedOption = FilterOption.find(
      (option) => option.value === newValue
    );
    if (selectedOption.value === 1) {
      ActiveFunction();
    } else if (selectedOption.value === 2) {
      DisableFunction();
    }
  };

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(policyList), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, policyList]
  );

  //Changed by Arun for Checkbox
  const checked = (checked, id, index) => {
    setCheckboxRows((prev) => ({ ...prev, [index]: checked }));
    checked
      ? checkedRows.push(id)
      : checkedRows.splice(checkedRows.indexOf(id), 1);
    console.log("checked rows ", checkedRows);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - policyList.length) : 0;

  const EditUserConfig = (row) => {
    GetUserConfigById(row._id).then((res) => {
      setOpenDrawer(true);
      setFormType("edit");
      setSelectedData(res.data);
    });
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.user},${el?.company},${el.bookingCode},${el?.subBookingCode
              },${el?.product},${el?.subProduct},${el?.policyType},${el?.CC},${el?.GVW
              },${el?.location},${el?.PACover},${el?.OD},${el?.TP},${el?.Net
              },${moment(el?.disableDate).format("DD/MM/YYYY")},${moment(
                el?.activeDate
              ).format("DD/MM/YYYY")}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData)
      .then((res) => {
        const modifiedUserDetails = res.data
          .map((e) => {
            if (e.userType.includes("user") && e.isEnabled) {
              // console.log(e);
              return {
                ...e,
                label: e?.name + " - " + e?.mobileNumber + " - " + e?.email,
                value: e._id,
              };
            }
          })
          .filter(Boolean);
        setUserDetails(modifiedUserDetails);
        setOpenLoader(false);
      })
      .catch((err) => {
        setOpenLoader(false);
      });
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      //isAscending added by gokul...
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails.sort());
    });
  };

  const GetBookingCodeDetails = () => {
    GetBookingCode({ isAscending: true }).then((res) => {
      const modifiedBookingCode = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.bookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setBookingCodeDetails(modifiedBookingCode);
    });
  };

  // subBookingCodeDetails added by gokul...

  const GetSubBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: true }).then((res) => {
      const modifiedSubBookingCode = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.subBookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);

      const filteredSubBookingCode = modifiedSubBookingCode.filter(
        (item) =>
          item.bookingCodeId === selectedBookingCode?._id ||
          item.bookingCodeId === selectedBookingCode
      );
      setSubBookingCodeDetails(filteredSubBookingCode);
    });
  };

  React.useEffect(() => {
    GetSubBookingCodeDetails();
  }, [selectedBookingCode]);

  React.useEffect(() => {
    GetCompanyDetails();
    GetBookingCodeDetails();
    GetUserDetails();
  }, []);

  const header = [
    { label: "User", key: "user" },
    { label: "Company Name", key: "company" },
    { label: "Booking Code", key: "bookingCode" },
    { label: "Sub Booking Code", key: "subBookingCode" },
    { label: "Product", key: "product" },
    { label: "Sub Product", key: "subProduct" },
    { label: "Policy Type", key: "policyType" },
    { label: "CC", key: "CC" },
    { label: "GVW", key: "GVW" },
    { label: "RTO Code", key: `location` },
    { label: "PA Cover", key: "PACover" },
    { label: "OD%", key: "OD" },
    { label: "TP%", key: "TP" },
    { label: "NET%", key: "Net" },
    { label: "Active Date", key: "ActiveDate" },
    { label: "Disable Date", key: "DisableDate" },
  ];
  const csvFile = {
    filename: "User Payable Data",
    headers: header,
    data: policyList,
  };

  const ActiveFunction = () => {
    setReqType("ACTIVE");
    setPage(0);
    // The useEffect will automatically handle the API call when reqType changes
  };

  const DisableFunction = () => {
    setReqType("DISABLED");
    setPage(0);
    // The useEffect will automatically handle the API call when reqType changes
  };
  // Changed by Arun
  const DeleteMultipleUserConfigData = () => {
    if (checkedRows.length == 0) {
      ToastError("Please select record");
    } else {
      setOpenMultipleDeleteConfirmBox(true);
    }
  };
  // Changed by Arun
  const DeleteMultipleFunction = () => {
    DeleteMultipleUserConfigById(checkedRows).then((res) => {
      setCheckedRows([]);
      setCheckboxRows({});
      reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
      console.log("checked rows ", checkedRows);
      console.log("check box rows ", checkboxRows);
    });
    setOpenMultipleDeleteConfirmBox(false);
  };

  const DeleteUserConfigData = (row) => {
    setOpenDeleteConfirmBox(true);
    setSelectedData(row);
  };
  const DeleteFunction = () => {
    DeleteUserConfig(selectedData._id).then((res) => {
      reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
    });
    setOpenDeleteConfirmBox(false);
  };
  // Changed by Arun
  const DisableMultipleUserConfigData = (row) => {
    if (checkedRows.length == 0) {
      ToastError("Please select record");
    } else {
      setDisabledDate("React-disable");
      setOpenConfirmBox(true);
    }
  };

  const ActiveUserConfigData = (row) => {
    setDisabledDate("React-disable");
    setOpenConfirmBox(true);
    setSelectedData(row);
  };

  const DisableUserConfigFunction = (selectedDate) => {
    const requesttype = selectedData.isEnabled ? "true" : "false";
    const headers = {
      requesttype: requesttype,
      disableDate: selectedDate,
    };
    // console.log("headers ", headers);
    // return true;
    // Changed by Arun
    if (checkedRows.length > 0) {
      disableMultipleUserConfigById(checkedRows, headers).then((res) => {
        setCheckedRows([]);
        setCheckboxRows({});
        reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
        setOpenConfirmBox(false);
      });
    } else {
      DisableUserConfig(selectedData._id, headers).then((res) => {
        reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
        setOpenConfirmBox(false);
      });
    }
  };

  const handleDateChange = (date) => {
    console.log("Selected date from child:", date);
    setDisabledDate(date); // receive date from child
  };

  // added by gokul....
  useEffect(() => {
    if (!reqType) return; // Wait for reqType to be set

    // Show loader
    setOpenLoader(true);

    // Ensure userId is always a string - convert null/undefined to "undefined"
    const userId = selectedUser?._id || selectedUser;
    const userIdString =
      userId === null || userId === undefined ? "undefined" : userId;

    GetUserConfigByUserId(userIdString, {
      requestType: reqType,
      companyId: selectedCompany?._id || selectedCompany,
      bookingCodeId: selectedBookingCode?._id || selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode?._id || selectedSubBookingCode,
    })
      .then((res) => {
        const formattedData = res.data.map((e) => {
          const baseData = {
            ...e,
            ActiveDate: moment(e.activeDate).format("DD/MM/YYYY"),
          };
          // Add DisableDate for DISABLED request type
          if (reqType === "DISABLED" && e.disableDate) {
            baseData.DisableDate = moment(e.disableDate).format("DD/MM/YYYY");
          }
          return baseData;
        });
        setPolicyList(formattedData);
      })
      .catch((error) => {
        console.error("Error fetching user config:", error);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  }, [searchTrigger, reqType]);

  useEffect(() => {
    if (policyList.length > 0) {
      const products = [...new Set(policyList.map((item) => item.product))]
        .filter(Boolean)
        .map((p) => ({ label: p, _id: p }));
      setProductFilterData(products);

      const policies = [...new Set(policyList.map((item) => item.policyType))]
        .filter(Boolean)
        .map((p) => ({ label: p, _id: p }));
      setPolicyFilterData(policies);
    }
  }, [policyList]);

  useEffect(() => {
    // setOpenLoader(true);
    setReqType("ACTIVE");
    GetUserConfigByUserId("undefined", { requestType: "ACTIVE" })
      .then((res) => {
        const formattedData = res.data.map((e) => {
          return {
            ...e,
            ActiveDate: moment(e.activeDate).format("DD/MM/YYYY"),
          };
        });
        // console.log(formattedData)
        setPolicyList(formattedData);
      })
      .catch((error) => {
        console.error("Error fetching user config:", error);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  }, []);

  const handleMultiDelete = (items) => {
    console.log(items, "II");
    setCheckedRows(items);
  };

  const handleClose = () => setOpenConfirmBox(false);

  const handleClearAllState = () => {
    setSelectedUser(null);
    setSelectedCompany(null);
    setSelectedBookingCode(null);
    setSelectedSubBookingCode(null);
    setSelectedBranch(null);
    setSelectedProduct(null);
    setSelectedPolicy(null);
    setSelectedFilterType(null);
    setDateRange([null, null]);
    // Trigger search after clearing
    setSearchTrigger((prev) => prev + 1);
  };

  const handleClearSingleFilter = (filterId) => {
    // Clear the specific filter based on ID
    // The useEffect will automatically handle the API call and loader when state changes
    if (filterId === 1) {
      setSelectedUser(null);
    } else if (filterId === 2) {
      setSelectedCompany(null);
    } else if (filterId === 3) {
      setSelectedBookingCode(null);
      setSelectedSubBookingCode(null); // Also clear sub booking code when booking code is cleared
    } else if (filterId === 4) {
      setSelectedSubBookingCode(null);
    } else if (filterId === 5) {
      setSelectedBranch(null);
    } else if (filterId === 6) {
      setSelectedProduct(null);
    } else if (filterId === 7) {
      setSelectedPolicy(null);
    } else if (filterId === 8) {
      setDateRange([null, null]);
    } else if (filterId === 9) {
      setSelectedFilterType(null);
    }
    // Trigger search after clearing
    setSearchTrigger((prev) => prev + 1);
  };

  const handleSaveAllFilter = () => {
    // Trigger the API call by incrementing searchTrigger
    // This will cause the useEffect to run with current filter values
    setSearchTrigger((prev) => prev + 1);
  };
  const [dateRange, setDateRange] = useState([null, null]);

  const filterBoxData = [
    {
      id: 1,
      label: "Select User",
      data: userDetails,
      setState: setSelectedUser,
      value: selectedUser,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Select Company",
      data: companyDetails,
      setState: setSelectedCompany,
      value: selectedCompany,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Select Booking Code",
      data: bookingCodeDetails,
      setState: setSelectedBookingCode,
      value: selectedBookingCode,
      type: "input",
      variation: "single",
    },
    {
      id: 4,
      label: "Select SubBookingCode",
      data: subBookingCodeDetails,
      setState: setSelectedSubBookingCode,
      value: selectedSubBookingCode,
      type: "input",
      variation: "single",
    },
  ];

  const activeFiltersCount =
    [
      selectedUser,
      selectedCompany,
      selectedBookingCode,
      selectedSubBookingCode,
      selectedBranch,
      selectedProduct,
      selectedPolicy,
      selectedFilterType,
    ].filter(Boolean).length + (dateRange[0] ? 1 : 0);

  // Add new filters to filterBoxData
  const extendedFilterBoxData = filterBoxData;

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    User Configuration
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        startIcon={
                          <DeleteIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={() => DeleteMultipleUserConfigData()}
                      >
                        Delete
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button  w-100"
                        startIcon={
                          <NotInterestedIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={() => DisableMultipleUserConfigData()}
                      >
                        Disable
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            color="error"
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        fullWidth
                        startIcon={
                          <CloudDownloadOutlinedIcon
                            sx={{
                              color: "#344054",
                            }}
                          />
                        }
                      >
                        <CSVLink
                          style={{ textDecoration: "none", color: "inherit" }}
                          {...csvFile}
                        >
                          Export
                        </CSVLink>
                      </Button>
                      <Button
                        className="Master_Card_create_Button w-100"
                        startIcon={
                          <AddIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={() => {
                          setOpenDrawer(true);
                          setFormType("add");
                          setSelectedData({});
                        }}
                      >
                        Create
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={extendedFilterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                className="Master_Card_Sub_Container"
              >
                <TabFilter
                  options={FilterOption}
                  selectedTab={selectedTab}
                  onTabChange={handleTabChange}
                />
                <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search in Access"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={FilteredData}
                columns={headCells}
                handleEdit={EditUserConfig}
                handleDelete={DeleteUserConfigData}
                handleApprove={ActiveUserConfigData}
                handleMultiDelete={handleMultiDelete}
                tableTotalCount={filter.fn(policyList)?.length || 0}
                loading={openLoader}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      <Dialog
        open={openDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            maxWidth: {
              xs: "80%",
              sm: "70%",
              md: "50%",
              lg: "60%",
            },
          },
        }}
      >
        {openDrawer ? (
          <AddUserConfig
            setOpenDrawer={setOpenDrawer}
            selectedUser={selectedUser}
            ActiveFunction={ActiveFunction}
            selectedData={selectedData}
            formType={formType}
          />
        ) : null}
      </Dialog>
      <ConfirmBox
        open={openDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenDeleteConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
        color="error"
      />
      <ConfirmBox
        open={openMultipleDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenMultipleDeleteConfirmBox}
        Function={DeleteMultipleFunction}
        icon={<DeleteIcon />}
        color="error"
      />
      <ConfirmBox
        setDisabledDate={handleDateChange}
        disabledDate={disabledDate}
        mode="picker"
        open={openConfirmBox}
        title="Disable"
        content={
          disabledDate === "React-disable"
            ? "Please select the date ... !"
            : "Are you sure want to disable"
        }
        confirmButton="Disable"
        setOpenConfirmBox={setOpenConfirmBox}
        onClose={handleClose}
        Function={DisableUserConfigFunction}
        icon={<NotInterestedIcon />}
        color="error"
        img={DisabledImage}
        subContent="Select a valid date before proceeding."
      />
    </>
  );
};
export default UserConfig;
